import * as e from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/Image.es.js";
const o = e.forwardRef((a, m) => /* @__PURE__ */ e.createElement(r, { ref: m, ...a, weights: t }));
o.displayName = "ImageIcon";
const I = o;
export {
  I as Image,
  o as ImageIcon
};
